module.exports = __webpack_public_path__ + "media/base/file_whole-4021bb93.svg";